import React from 'react';
import './InvestmentConsultation.scss'
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class InvestmentConsultation extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/investbanner.png"), imgHDPath: `${require("img/Products/investbanner.png")} 1x,${require("img/Products/investbanner@2x.png")} 2x,${require("img/Products/investbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '城镇化项目投融资咨询',
          data: '城镇化领域的基础设施、片区开发和城市综合体项目，投资规模大，投资回收期长，与区域经济社会整体发展质量和地方政府长期综合财力直接相关。城镇化项目投融资咨询业务，旨在构建地方政府、政府投资公司（融资平台）、金融机构、各类市场化主体合作顺畅的投融资机制，促成各方有效发挥各种资源与能力优势，形成激励相容的合作机制，筹集低成本资金支撑重大项目的高水平运作。',
          imgPath: require("img/Products/investpic1.png"), imgHDPath: `${require("img/Products/investpic1.png")} 1x,${require("img/Products/investpic1@2x.png")} 2x,${require("img/Products/investpic1@3x.png")} 3x`
        },
        {
          title: '工程前期咨询与评估咨询',
          data: '遵循独立、科学、公正的原则，运用工程技术、科学技术、经济管理和法律法规等多学科知识和经验，为建筑、市政公用工程、公路、水利水电、电力、生态环境、农业等建设项目的项目业主或主管部门提供项目决策和评估评价等咨询服务。',
          imgPath: require("img/Products/investpic2.png"), imgHDPath: `${require("img/Products/investpic2.png")} 1x,${require("img/Products/investpic2@2x.png")} 2x,${require("img/Products/investpic2@3x.png")} 3x`
        },
        {
          title: '政府和社会资本合作（PPP）咨询',
          data: 'PPP 咨询业务涵盖传统基础设施与公共服务领域，我们熟练掌握各类项目PPP 模式实施要点和程序，为客户提供两评一案编制、采购与合同谈判、中期绩效评价、移交方案咨询等服务，促进PPP项目落地并顺利运营，维护委托方利益。',
          imgPath: require("img/Products/investpic3.png"), imgHDPath: `${require("img/Products/investpic3.png")} 1x,${require("img/Products/investpic3@2x.png")} 2x,${require("img/Products/investpic3@3x.png")} 3x`
        }
      ],
      ascendentLists: [
        {
          title: '多专业甲级+PPP专项甲级',
          data: '电子、信息工程（含通信、广电、信息化）、市政公用工程、生态建设和环境工程、水利水电、电力（含火电、水电、核电、新能源）、公路、建筑，PPP咨询专项',
        },
        {
          title: '经验丰富、专业齐全的技术服务团队',
          data: '由注册咨询工程师、注册会计师、资产评估师、税务师以及具有中高级技术职称资格的专业人士组成',
        },
        {
          title: '项目业绩涉猎广泛',
          data: '多地区的城镇建设投融咨询、多行业的工程前期咨询、多维度的项目融资咨询',
        }
      ],
      caseList: [
        { imgs: require("img/Products/1、张家口市政府债务化解和投融资规划-min.png"), name: "张家口市政府债务化解和投融资规划" },
        { imgs: require("img/Products/2、张家口经开区“未来之城”投融资规划-min.jpg"), name: "张家口经开区“未来之城”投融资规划" },
        { imgs: require("img/Products/3、雄安新区体育教育基础设施投资运营模式分析咨询-min.jpg"), name: "雄安新区体育教育基础设施投资运营模式分析咨询" },
        { imgs: require("img/Products/4、宝鸡市自来水有限责任公司股权回购项目咨询-min.jpg"), name: "宝鸡市自来水有限责任公司股权回购项目咨询" },
        { imgs: require("img/Products/5、砚山县地方政府融资平台资源整合与能力建设综合咨询-min.jpg"), name: "砚山县地方政府融资平台资源整合与能力建设综合咨询" },
        { imgs: require("img/Products/6、张掖交投发展战略、功能定位和商业模式研究咨询-min.jpg"), name: "张掖交投发展战略、功能定位和商业模式研究咨询" },
        { imgs: require("img/Products/7、拉萨市城关区净土中央厨房建设项目专项债“一案两书”咨询-min.jpg"), name: "拉萨市城关区净土中央厨房建设项目专项债“一案两书”咨询" },
        { imgs: require("img/Products/8、某市高速公路债务化解咨询-min.jpg"), name: "某市高速公路债务化解咨询" },
        { imgs: require("img/Products/9、国务院国资委中央企业国有资本经营预算拟支持重大项目预评估咨询-min.jpg"), name: "国务院国资委中央企业国有资本经营预算拟支持重大项目预评估咨询" },
        { imgs: require("img/Products/10、国务院国资委中央企业PPP业务专项检查咨询-min.jpg"), name: "国务院国资委中央企业PPP业务专项检查咨询" },
        { imgs: require("img/Products/11、山西省忻州市经济开发区“新型半导体材料产业化”工业园项目可研编制咨询-min.jpg"), name: "山西省忻州市经济开发区“新型半导体材料产业化”工业园项目可研编制咨询" },
        { imgs: require("img/Products/12、安徽省滁州市餐厨垃圾处理PPP项目全过程咨询-min.jpg"), name: "安徽省滁州市餐厨垃圾处理PPP项目全过程咨询" },
      ],
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="InvestmentConsultation">
          <h5 className='product-title content-title'>服务优势</h5>
          <Lists dataLists={this.state.ascendentLists}></Lists>
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          <RelatedCases caseList={this.state.caseList} id={'InvestmentConsultation'} />
        </div>
      </main>
    )
  }
}
export default InvestmentConsultation
